import { type ExportFileField } from '../../export-file/ExportFileTypes.ts';

interface IConfigField {
  codice?: string | null;
  etichetta?: string | null;
}

/**
 * Mappa i campi di configurazione del Tipo Albo
 * in campi esportabili.
 */
export function mapConfigFieldsToExportFields(
  configFields: IConfigField[] | null | undefined,
): ExportFileField[] | undefined {
  if (!configFields) return undefined;
  return configFields
    .filter((field): field is IConfigField & { codice: string } =>
      Boolean(field?.codice?.trim()),
    )
    .map(field => ({
      id: field.codice,
      chiave: field.codice,
      titolo: field.etichetta,
    }));
}
